import { Box, IconButton, Popover, TextField, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CircleButton from "../../../AppButtons/CircleButton";
import {
  AppIconsActive,
  AppIconsAddNote,
  AppIconsClose,
  AppIconsMessage,
} from "../../../AppIcons";
import {
  BoxNoteOperationStyled,
  BoxNoteTextContainerStyled,
  useClasses,
} from "./NoteSimpleIconComponent.style";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";

type TNoteIconComponent = {
  item: any;
  additionalProps?: any;
};

export const NoteSimpleIconComponent = (props: TNoteIconComponent) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const classes = useClasses();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [text, setText] = useState<string>(props.item.note ?? "");

  const open = Boolean(anchorEl);
  const id = open ? "note-popover" + props.item.rowId : undefined;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isReadOnly) setAnchorEl(event.currentTarget);
  };

  const { t } = useTranslation();
  const isReadOnly: boolean =
    props.additionalProps != undefined &&
    props.additionalProps.readOnly !== undefined &&
    props.additionalProps.readOnly;

  const handleClose = (
    event: React.MouseEvent<HTMLElement> | KeyboardEvent
  ) => {
    setText((props.item.note ?? "").trim());
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleCancel = (
    event: React.MouseEvent<HTMLElement> | KeyboardEvent
  ) => {
    setText(props.item.note);
    handleClose(event);
  };
  const submitNote = (event: any) => {
    props.item.note = text;
    if (
      props.additionalProps !== undefined &&
      props.additionalProps.onSubmitItemNote !== undefined
    )
      props.additionalProps.onSubmitItemNote(
        props.item.rowId,
        textareaRef.current?.value.trim()
      );
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };

  
  useEffect(() => {
        if (["ORDER_FROM_OFFER","ORDER_FROM_WARRANTY"].every(value =>props.additionalProps.typeSubmit!== value)) {
            props.item.note = "";
            setText(props.item.note);
        }
  },[]);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value as string);
  };

  //
  return (
    <Box>
      <IconButton
        onClick={handleClick}
        style={{ cursor: isReadOnly ? "default" : "pointer" }}
      >
        <Tooltip
          children={
            props.item !== undefined &&
            props.item.note !== undefined &&
            props.item.note !== null &&
            props.item.note !== "" ? (
              <AppIconsMessage />
            ) : isReadOnly ? (
              <></>
            ) : (
              <AppIconsAddNote className="noNote" />
            )
          }
          title={props.item.note ?? ""}
          placement="right-end"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -14],
                  },
                },
              ],
            },
          }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <BoxNoteTextContainerStyled>
            <TextField
              inputRef={textareaRef}
              id={"comments_" + props.item.rowId}
              sx={classes.multiline}
              placeholder={t("orderoffer.addNotePart")}
              fullWidth
              margin="none"
              multiline
              variant="outlined"
              rows={3}
              value={text}
              onChange={handleInputChange}
            />

            <BoxNoteOperationStyled>
              <CircleButton onClick={handleCancel}>
                <AppIconsClose sx={classes.iconOperation} />
              </CircleButton>
              <CircleButton onClick={submitNote}>
                <AppIconsActive sx={classes.iconOperation} />
              </CircleButton>
            </BoxNoteOperationStyled>
          </BoxNoteTextContainerStyled>
        </Popover>
      </IconButton>
    </Box>
  );
};
